import {
    Sun, Moon, Utensils, Bus, BedDouble,
    Camera, Check, MessageCircle, Mail, Car, Plane
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CurFt from '../../components/CurFt';

export default function PackageCard({ pkg, SearchId }) {
    const navigate = useNavigate();
    const sortedCategories = Array.isArray(pkg.categories)
        ? [...pkg.categories].sort((a, b) => a.finalPrice - b.finalPrice)
        : [];
    const [selectedCategory, setSelectedCategory] = useState(
        sortedCategories[0] || null
    );
    const included = pkg.inclusion_names?.split(',');
    const trimmedArray = included.map(item => item.trim());
    const inclusions = pkg.inclusion_names?.split(",") || [];
    const visibleItems = inclusions.slice(0, 3);
    const remainingCount = inclusions.length - 3;

    const [showTooltip, setShowTooltip] = useState(false);


    return (
        <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition duration-300 overflow-hidden flex flex-col md:flex-row border border-gray-100" >
            <div className="w-full md:w-1/3 relative h-56 md:h-auto">
                <img src={pkg.Photo || "/placeholder.png"}
                    alt={pkg.PackageName}
                    onError={(e) => {
                        e.target.onerror = null; // prevent infinite loop
                        e.target.src = "/placeholder.png"; // path to your placeholder image
                    }}
                    className="h-[228px] object-cover" />
            </div>
            <div className="w-full md:w-2/3 p-4 flex flex-col md:flex-row gap-4">
                <div className="flex-1 relative pr-0 md:pr-6">
                    <span className="hidden md:block absolute top-4 bottom-4 right-0 w-px border-r-2 border-dashed border-gray-300"></span>
                    <span className="hidden md:block absolute -top-3 right-[-10px] w-5 h-5 bg-gray-50 rounded-full"></span>
                    <span className="hidden md:block absolute -bottom-3 right-[-10px] w-5 h-5 bg-gray-50 rounded-full"></span>
                    <div className="flex gap-2 mb-2">
                        {pkg.theme_names?.split(',').slice(0, 4).map(tag => (
                            <span key={tag} className="bg-gray-100 text-gray-500 text-[10px] px-2 py-1 rounded-sm uppercase 
                            font-semibold tracking-wide" >
                                {tag.trim()}
                            </span>
                        ))}
                    </div>
                    <h2 className="text-x2 font-bold text-gray-800 mb-2">
                        {pkg.PackageName}
                    </h2>
                    <div className="flex items-center gap-4 text-xs text-gray-600 mb-3">
                        <span className="flex items-center gap-1 font-medium text-gray-800">
                            {pkg.des_city_name}
                        </span>
                        <span className="flex items-center gap-1">
                            <Moon size={14} className="text-blue-900" />
                            {Number(pkg.PackageDuration)} Nights
                        </span>
                        <span className="flex items-center gap-1">
                            <Sun size={14} className="text-yellow-500" />
                            {Number(pkg.PackageDuration) + 1} Days
                        </span>
                    </div>
                    {/* <p className="text-xs text-gray-500 mb-4 font-medium line-clamp-3" dangerouslySetInnerHTML={{ __html: pkg.Summary }} /> */}
                    <div className="flex gap-4 mb-4">
                        {trimmedArray.includes('Hotel') && (
                            <div className="flex flex-col items-center gap-1 text-gray-400">
                                <BedDouble size={18} />
                                <span className="text-[10px]">Hotel</span>
                            </div>
                        )}
                        {trimmedArray.includes('Flight') && (
                            <div className="flex flex-col items-center gap-1 text-gray-400">
                                <Plane size={18} />
                                <span className="text-[10px]">Flight</span>
                            </div>
                        )}

                        {['All Meals - AP', 'Breakfast - CP', 'Breakfast & Dinner - MAP', 'Breakfast & Dinner - MAP'].some(option => trimmedArray.includes(option)) && (
                            <div className="flex flex-col items-center gap-1 text-gray-400">
                                <Utensils size={18} />
                                <span className="text-[10px]">Meals</span>
                            </div>
                        )}

                        {['Cab Transfer', 'Airport Transfers', 'Shuttle Service'].some(option => trimmedArray.includes(option)) && (
                            <div className="flex flex-col items-center gap-1 text-gray-400">
                                <Car size={18} />
                                <span className="text-[10px]">Transfer</span>
                            </div>
                        )}

                        {['Sightseeing'].some(option => trimmedArray.includes(option)) && (
                            <div className="flex flex-col items-center gap-1 text-gray-400">
                                <Camera size={18} />
                                <span className="text-[10px]">Sightseeing</span>
                            </div>
                        )}
                    </div>
                    {/* <div className="flex flex-wrap gap-x-4 gap-y-2">
                        {pkg.inclusion_names?.split(',').map(item => (
                            <div key={item} className="flex items-center gap-1 text-[11px] text-teal-700 bg-teal-50 px-2 py-0.5 rounded">
                                <Check size={10} strokeWidth={4} />
                                {item.trim()}
                            </div>
                        ))}
                    </div> */}

                    <div className="relative flex flex-wrap gap-x-1 gap-y-1">

                        {/* Show first 3 */}
                        {visibleItems.map((item, index) => (
                            <div
                                key={index}
                                className="flex items-center gap-1 text-[11px] text-teal-700 bg-teal-50 px-2 py-0.5 rounded"
                            >
                                <Check size={10} strokeWidth={4} />
                                {item.trim()}
                            </div>
                        ))}

                        {/* +More Button */}
                        {remainingCount > 0 && (
                            <div
                                className="relative"
                                onMouseEnter={() => setShowTooltip(true)}
                                onMouseLeave={() => setShowTooltip(false)}
                            >
                                <div className="text-[11px] text-blue-600 cursor-pointer">
                                    +{remainingCount}
                                </div>
                            </div>
                        )}
                    </div>

                </div>
                {/* Tooltip */}
                {showTooltip && (
                    <div className="absolute z-50 mt-10 w-64 bg-white border border-gray-200 shadow-lg rounded p-3 text-xs text-teal-700">
                        {inclusions.map((item, index) => (
                            <div key={index} className="flex items-center gap-1 mb-1 bg-teal-50 px-2 py-0.5">
                                <Check size={10} strokeWidth={3} />
                                {item.trim()}
                            </div>
                        ))}
                    </div>
                )}
                <div className="w-full md:w-48 flex flex-col justify-between items-end md:pl-2 shrink-0">
                    <div className="w-full text-right">
                        {pkg.categories?.length > 0 && selectedCategory && (
                            <select value={selectedCategory.pack_cat_id} onChange={(e) => {
                                const selected = pkg.categories.find(c => c.pack_cat_id == e.target.value);
                                setSelectedCategory(selected);
                            }} className="w-full mb-2 text-xs border border-gray-300 rounded px-2 py-1" >
                                {pkg.categories.map(cat => (
                                    <option key={cat.pack_cat_id} value={cat.pack_cat_id}>
                                        {cat.category_name}
                                    </option>
                                ))}
                            </select>
                        )}
                        {selectedCategory && (
                            <>
                                {/* {selectedCategory.beforediscountprice != selectedCategory.finalPrice &&
                                    <span className="bg-green-100 text-green-700 text-[10px] font-bold px-2 py-1 rounded border border-green-200 inline-block mb-2">
                                        {Math.round(
                                            ((selectedCategory.beforediscountprice - selectedCategory.finalPrice) /
                                                selectedCategory.beforediscountprice) * 100
                                        )}% Off
                                    </span>
                                } */}
                                <div className="text-xs text-gray-400 mb-1">
                                    Starting Price {selectedCategory?.priceResult?.name}
                                </div>
                                <div className="flex items-baseline justify-end gap-2">
                                    {selectedCategory.beforediscountprice != selectedCategory.finalPrice &&
                                        <span className="text-md text-gray-400 line-through decoration-red-500">
                                            <CurFt currency={pkg.currency.name || 'INR'} price={Math.ceil(parseFloat(selectedCategory.beforediscountprice))} />
                                        </span>
                                    }
                                    <span className="text-2xl font-bold text-gray-800">
                                        <CurFt currency={pkg.currency.name || 'INR'} price={Math.ceil(parseFloat(selectedCategory.finalPrice))} />
                                    </span>
                                </div>
                                <div className="flex items-baseline justify-end gap-2">

                                    {pkg.PackageCategory === 0 && (
                                        <span className="text-xs font-normal text-gray-600">
                                            Departure from {pkg.dep_city_name}
                                        </span>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                    <div className="w-full flex flex-col gap-2 mt-4">
                        <button disabled={!selectedCategory}
                            onClick={() =>
                                navigate(
                                    `/Holidays/details/${pkg.id}?cat=${selectedCategory.pack_cat_id}&ratecard=${selectedCategory.rate_card_group}&SearchId=${SearchId}&hotelOptions=${JSON.stringify(selectedCategory.hotelOptions)}`
                                )}
                            className="w-full bg-blue-500 hover:bg-blue-600 disabled:opacity-50 text-white font-bold py-2 rounded text-sm transition" >
                            View Details
                        </button>
                        <div className="flex gap-2">
                            <button
                                onClick={() =>
                                    navigate(
                                        `/Holidays/details/${pkg.id}?cat=${selectedCategory.pack_cat_id}&ratecard=${selectedCategory.rate_card_group}&SearchId=${SearchId}&hotelOptions=${JSON.stringify(selectedCategory.hotelOptions)}`
                                    )}
                                className="flex-1 border border-blue-900 text-blue-900 hover:bg-blue-50 font-semibold py-2 rounded text-sm flex items-center justify-center gap-2">
                                <Mail size={16} /> Enquire Now
                            </button>
                            {/* <button className="p-2 border border-green-500 text-green-500 rounded hover:bg-green-50">
                                <MessageCircle size={18} />
                            </button> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
